import type { ContractShapeOf, RequestHandlers } from 'shared/channels';
import type { inspectionContract } from 'shared/domain/inspection/inspectionContract';
import { inspectionSaver } from './addInspection';
import { inspectionDeleter } from './deleteInspection';
import { inspectionEditor } from './editInspection';
import { protocolAnswerEditor } from './editProtocolAnswer';
import { protocolItemEditor } from './editProtocolItem';
import { protocolSectionEditor } from './editProtocolSection';
import { protocolSectionAnswersBatchEditor } from './editProtocolSectionAnswersBatch';
import { inspectionRestorer } from './restoreInspection';

/**
 * Inspection and protocol changes put on the HTTP queue, as the channel server
 * runs them; each resolves once queued and its outcome follows as an event
 * with the change's `uniqueId`.
 */
export const queueInspectionChanges = {
  create: ({ templateId, inspectionOutDto, projectId, uniqueId }) =>
    inspectionSaver.execute(templateId, inspectionOutDto, projectId, uniqueId),
  edit: ({ inspectionId, inspectionOutDto, uniqueId, projectId }) =>
    inspectionEditor.execute(inspectionId, inspectionOutDto, uniqueId, projectId),
  remove: (change) => inspectionDeleter.execute(change),
  restore: (change) => inspectionRestorer.execute(change),
  editProtocolItem: ({ inspectionId, protocolItemId, protocolItemOutDto, uniqueId, projectId }) =>
    protocolItemEditor.execute(inspectionId, protocolItemId, protocolItemOutDto, uniqueId, projectId),
  editProtocolAnswer: ({ inspectionId, protocolItemId, protocolAnswerId, protocolAnswerOutDto, uniqueId, projectId }) =>
    protocolAnswerEditor.execute(inspectionId, protocolItemId, protocolAnswerId, protocolAnswerOutDto, uniqueId, projectId),
  editProtocolSection: ({ inspectionId, sectionId, protocolSectionOutDto, uniqueId, projectId }) =>
    protocolSectionEditor.execute(inspectionId, sectionId, protocolSectionOutDto, uniqueId, projectId),
  editProtocolSectionAnswers: ({
    inspectionId,
    sectionId,
    protocolSectionAnswersBatchOutDto,
    protocolItemIds,
    uniqueId,
    projectId,
  }) =>
    protocolSectionAnswersBatchEditor.execute(
      inspectionId,
      sectionId,
      protocolSectionAnswersBatchOutDto,
      protocolItemIds,
      uniqueId,
      projectId
    ),
} satisfies RequestHandlers<ContractShapeOf<typeof inspectionContract>>;
